const navigation = [
    {
        name: 'Facebook',
        href: 'https://www.facebook.com/mobilitus',
        icon: (props) => (<i className="fa-brands fa-facebook"></i>),
    }, {
        name: 'LinkedIn',
        href: 'https://www.linkedin.com/company/mobilitus',
        icon: (props) => (<i className="fa-brands fa-linkedin"></i>),
    }, ]


export default function MobilitusFooter() {

    let now = new Date();


    return (
        <footer className="bg-white">
            <div className="mx-auto max-w-7xl px-6 py-12 md:flex md:items-center md:justify-between lg:px-8">
                <div className="flex justify-center gap-x-6 md:order-2">
                    {navigation.map((item) => (
                        <a key={item.name} href={item.href} className="text-gray-600 hover:text-gray-800">
                            <span className="sr-only">{item.name}</span>
                            <item.icon aria-hidden="true" className="w-6 h-6" />
                        </a>
                    ))}
                </div>
                <p className="mt-8 text-center text-sm/6 text-gray-600 md:order-1 md:mt-0">
                    &copy; {now.getFullYear()} Mobilitus, Inc. All rights reserved.
                </p>
            </div>
        </footer>
    )
}
